var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from "react";
import styled from "styled-components";
import Slider from "@irati/ui/src/Slider";
import id from "@irati/utils/id";
import { minWidthMedia, PHONE, PHONE_LANDSCAPE, TABLET } from "@irati/ui/src/global/media";
import TrophyImg from "@irati/ui/src/Trophy";
import { TrophyButton } from "./styled";
import { CustomTrophy } from "./";
var Wrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  .slick-slider {\n    height: 120px;\n    display: flex;\n  }\n  .slick-slide {\n    width: 120px !important; /* required to override width styling from react-slick */\n  }\n  ", "\n  ", "\n"], ["\n  width: 100%;\n  position: relative;\n  .slick-slider {\n    height: 120px;\n    display: flex;\n  }\n  .slick-slide {\n    width: 120px !important; /* required to override width styling from react-slick */\n  }\n  ",
    "\n  ", "\n"])), minWidthMedia.tablet(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: ", ";\n  "], ["\n    width: ", ";\n  "])), function (props) { return props.sliderWidth; }), function (props) { return !props.show && "display: none;"; });
var MobileResponsiveWidth = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  max-width: 240px;\n  margin: auto;\n  ", "\n"], ["\n  max-width: 240px;\n  margin: auto;\n  ",
    "\n"])), minWidthMedia.phone(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    max-width: 100%;\n  "], ["\n    max-width: 100%;\n  "]))));
var InlineTrophies = /** @class */ (function (_super) {
    __extends(InlineTrophies, _super);
    function InlineTrophies() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            selected: _this.props.item.trophy,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                responsive: [
                    { breakpoint: PHONE - 1, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                    { breakpoint: PHONE_LANDSCAPE, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                    { breakpoint: TABLET, settings: { slidesToShow: 4, slidesToScroll: 4 } }
                ]
            },
            isCustom: false
        };
        _this.handleSave = function (selected) {
            _this.setState({ selected: selected, isCustom: false });
            var onChange = _this.props.onChange;
            // remove id prop from trophy
            var _ = selected.id, trophy = __rest(selected, ["id"]);
            onChange(trophy);
        };
        _this.handleCustomImage = function (href) {
            var onChange = _this.props.onChange;
            var image = {
                alt: "custom-image-uploaded",
                href: href
            };
            _this.setState({ selected: image, isCustom: true });
            onChange(image);
        };
        _this.isSelected = function (trophy, item) {
            var selected = _this.state.selected;
            if (!selected && !item.trophy) {
                return false;
            }
            return selected.href === trophy.href || trophy.href === item.href;
        };
        return _this;
    }
    InlineTrophies.prototype.componentDidMount = function () {
        var _this = this;
        var settings = this.state.settings;
        var _a = this.props, item = _a.item, trophies = _a.trophies;
        if (item.trophy) {
            var index = trophies.findIndex(function (trophy) { return _this.isSelected(trophy, item); });
            var slideToGoTo = Math.floor(index / this.slider.getSlidesToShow(settings)) * this.slider.getSlidesToShow(settings);
            this.slider.slickSlider.current.slickGoTo(slideToGoTo);
        }
    };
    InlineTrophies.prototype.render = function () {
        var _this = this;
        var _a = this.props, trophies = _a.trophies, show = _a.show, item = _a.item, sliderWidth = _a.sliderWidth, updateError = _a.updateError;
        var _b = this.state, settings = _b.settings, isCustom = _b.isCustom;
        return (React.createElement(Wrapper, { show: show, sliderWidth: sliderWidth },
            React.createElement(MobileResponsiveWidth, null,
                React.createElement(Slider, { settings: settings, ref: function (c) { _this.slider = c; } },
                    React.createElement(CustomTrophy, { setError: updateError, selected: isCustom, onUpload: function (uploaded) { return _this.handleCustomImage(uploaded); }, trophy: undefined }),
                    trophies.map(function (trophy, i) {
                        return React.createElement(TrophyButton, { key: trophy.id, id: id("button" + i, _this.props), selected: _this.isSelected(trophy, item), onClick: function () { return _this.handleSave(trophy); } },
                            React.createElement(TrophyImg, { src: trophy.href }));
                    })))));
    };
    InlineTrophies.defaultProps = {
        id: "selectTrophy"
    };
    return InlineTrophies;
}(Component));
export default InlineTrophies;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
